import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3e4d847c"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "insights-card" };
const _hoisted_2 = { class: "insights-card__content" };
const _hoisted_3 = { class: "insights-card__header" };
const _hoisted_4 = ["title"];
const _hoisted_5 = ["src"];
const _hoisted_6 = { class: "insights-card__description" };
const _hoisted_7 = { class: "insights-card__description-text" };
const _hoisted_8 = { class: "insights-card__description-text" };
const _hoisted_9 = { class: "insights-card__description-text" };
const _hoisted_10 = ["href"];
const _hoisted_11 = ["src"];
import { ref, onMounted } from 'vue';
import { useLottie } from '@/composables/useLottie';
import campaignEndingSoonAnimation from '@/assets/json/campaign-ending-soon.json';
import { useMixpanelConfig } from '@/utilities/mixpanel';
import { maxCampaignNameLength, truncateName } from '../utils';
export default /*#__PURE__*/ _defineComponent({
    __name: 'EndOfLifeCard',
    props: {
        insight: {}
    },
    setup(__props) {
        const props = __props;
        const animationContainerRef = ref(null);
        const { loadAnimation: loadCampaignEndingSoonAnimation } = useLottie(animationContainerRef, {
            animationData: campaignEndingSoonAnimation,
        });
        function handleCardLink() {
            useMixpanelConfig('click_campaign_ending_cta');
        }
        onMounted(() => {
            loadCampaignEndingSoonAnimation();
        });
        return (_ctx, _cache) => {
            const _component_el_tooltip = _resolveComponent("el-tooltip");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("h3", null, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t('strategic-insights.card.title.first-part')), 1),
                            _createElementVNode("strong", {
                                title: props.insight.action.length > _unref(maxCampaignNameLength) ? props.insight.action : ''
                            }, _toDisplayString(_unref(truncateName)(props.insight.action)), 9, _hoisted_4),
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t('strategic-insights.card.title.second-part')), 1)
                        ]),
                        _createVNode(_component_el_tooltip, {
                            content: _ctx.$t('strategic-insights.card.title.tooltip-content'),
                            placement: "bottom",
                            "popper-class": "insights-card__tooltip"
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("img", {
                                    src: require(`@/assets/svgs/question-outline.svg`)
                                }, null, 8, _hoisted_5)
                            ]),
                            _: 1
                        }, 8, ["content"])
                    ]),
                    _createElementVNode("div", {
                        ref_key: "animationContainerRef",
                        ref: animationContainerRef,
                        class: "insights-card__animation"
                    }, null, 512),
                    _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("p", _hoisted_7, [
                            _createElementVNode("strong", null, _toDisplayString(_ctx.$t('strategic-insights.card.description.highlighted', { percent: props.insight.percent })), 1)
                        ]),
                        _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t('strategic-insights.card.description.first-paragraph')), 1),
                        _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t('strategic-insights.card.description.second-paragraph')), 1)
                    ])
                ]),
                _createElementVNode("a", {
                    href: props.insight.link,
                    target: "_blank",
                    class: "insights-card__btn",
                    rel: "noopener noreferrer",
                    referrerpolicy: "no-referrer-when-downgrade",
                    onClick: handleCardLink
                }, [
                    _createElementVNode("img", {
                        src: require(`@/assets/svgs/rocket-blue.svg`)
                    }, null, 8, _hoisted_11),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('strategic-insights.card.link')), 1)
                ], 8, _hoisted_10)
            ]));
        };
    }
});
